import React, { useEffect, useState } from "react";
import { SeatingService, TransRoutesService } from "../../services";
import moment from 'moment';


const BreakfastSection = ({seatingLayout, breakfastRecords, sectionName, confimHasBreakfast, removeBreakfastRecord, selectedDate, refreshRecords, canEdit = false}) => {
	const [customers, setCustomers] = useState([]);

	const createBreakfastForAll = async () => {
		const dateStr = moment(selectedDate || new Date()).format('MM/DD/YYYY');
		const unconfirmed = customers.filter(c => !c.has_breakfast);
		for (const c of unconfirmed) {
			await TransRoutesService.createBreakfastRecords({
				customer_id: c?.customer_id,
				customer_name: c?.customer_name,
				has_breakfast: true,
				date: dateStr,
				create_by: localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))?.name,
				create_date: new Date(),
				edit_history: [{
					employee: localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))?.name,
					date: new Date()
				}]
			})
		};
		if (refreshRecords) refreshRecords();
	}

	useEffect(() => {
		const chartCustomers = SeatingService.getAllCustomersFromSeatingChart(
			seatingLayout,
			breakfastRecords || [],
			'has_breakfast'
		);
		setCustomers(chartCustomers);
	}, [breakfastRecords, seatingLayout]);



	
  
  return (
    <>
      <div className="text-primary mb-4"><h5>{sectionName} {` (${customers?.length})`}</h5></div>
	  {canEdit && customers?.some(c => !c.has_breakfast) && (<div className="mb-2 mt-2"><button onClick={() => createBreakfastForAll()} className="btn btn-primary btn-sm">Confirm All Breakfast</button></div>)}
      <div className="list row">
        <div className="col-md-12">
					<table className="personnel-info-table">
            <thead>
              <tr>
								<th>Name</th>
								<th>Has Breakfast Today</th>
								{canEdit && <th>Change Breakfast Status</th>}
							</tr>
						</thead>
					<tbody>
						{
							customers?.map((customer) => (
								<tr key={customer?.customer_id} className={customer?.has_breakfast ? 'light-green' : 'red'}>
									<td>{customer?.customer_name}</td>
									<td>{customer?.has_breakfast ? 'Yes': 'No'}</td>
									{canEdit && <td>
										{!customer?.has_breakfast && <button className="btn btn-link btn-sm" onClick={() => confimHasBreakfast(customer)}>Confirm Customer Has breakfast</button>}
										{customer?.has_breakfast && <button className="btn btn-link btn-sm" onClick={() => removeBreakfastRecord(customer?.customer_id)}>Mark Customer NOT have breakfast</button>}
									</td>}
								</tr>
							))
						}
					</tbody>
					</table>
        </div>
      </div>
    </>
    
  );
};

export default BreakfastSection;